import React, {useCallback} from "react";
import Leaf from "./Leaf";

export default function useRenderLeaf(){
    return useCallback((props)=>(<Leaf {...props} />),[]);
}